import React from "react";

import { Count, Link, SourceData, SourceTitle, SourceWrapper } from "./style";

const Source = ({ source, link, index }) => (
  <SourceWrapper>
    <Count variant="paragraph2">{index + 1}.</Count>
    <SourceData>
      <SourceTitle variant="paragraph2">{source}</SourceTitle>
      <Link variant="link2" target="_blank" href={link}>
        {link}
      </Link>
    </SourceData>
  </SourceWrapper>
);

export default Source;
